<template>
  <div class="page-wrapper">


    <search-group title="" @search="findData" @clear="clearValue" :span="24" :btnOffset="20" :btnSpan="6"
                  :multipleLines="false" :inline="true"
                  style="padding: 0"
    >
      <Row class="mb16" :gutter="16">
        <Col span="6">
          <Select v-model="searchData.projectFid" placeholder="项目名称">
            <Option value=''>请选择</Option>
            <Option v-for="(item,index) in projectList" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>
          </Select>
        </Col>
        <Col span="4">
<!--          <Select v-model="searchData.belongToMonth" placeholder="归属月份">-->
<!--            &lt;!&ndash;            <Option value=''>请选择</Option>&ndash;&gt;-->
<!--            &lt;!&ndash;            <Option v-for="(item,index) in projectList" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>&ndash;&gt;-->
<!--          </Select>-->

          <DatePicker type="month"
                      v-model="searchData.belongToMonth"
                      format="yyyy-MM"
                      placeholder="归属月份" style="display: block"></DatePicker>
        </Col>
        <Col span="8">
          <DatePicker style="width:100%" v-model="searchData.createTime" split-panels type="daterange" format="yyyy-MM-dd"
                      placeholder="创建日期筛选"></DatePicker>
        </Col>
      </Row>
    </search-group >
    <div>
      <Button type="primary" @click.stop="addN++" v-p="{api:'storeFrontGrade/addStoreFrontGrade'}">新增</Button>
    </div>
    <table-list
      class="mt12"
      :columns="columns"
      :data="data"
      :current="current"
      :total="total"
      :loading="loading"
      @change-page="changPage"
    ></table-list>
    <add :projectList="projectList" :n="addN" :typeList="typeList"  @done="findData"></add>
  </div>
</template>

<script type="text/ecmascript-6">
  import SearchGroup from 'components/SearchGroup/index';
  import {formatDateTime} from "../../../utils/format";
  import TableList from 'components/TableList/index';
import {findStoreFrontGradeList,deleteStoreFrontGrade} from "../../../api/grade";
import Add from './components/Add'
  import {getProjects} from "../../../api/common";
import {findWorkOrderTypeList} from "../../../api/grade";

  export default {
    name:'grade',
    components: {
      SearchGroup,
      TableList,
      Add
    },
    mounted() {
      getProjects().then(res => {
        if(!res.data){
          return
        }
        this.projectList = res.data
      }).catch(error => {
      })

      findWorkOrderTypeList({type: 4,parentFid:-1}).then(res => {
        if(!res.data){
          return

        }
        this.typeList=res.data

      }).catch(error => {

      })

      this.findData()
    },
    computed: {
      searchDataComputed() {
        function f(data) {
          return data ? formatDateTime(data, false) : ''
        }
        return {
          projectFid: this.searchData.projectFid,
          startDate: f(this.searchData.createTime[0]),
          endDate:f(this.searchData.createTime[1]),
          belongMonth:f(this.searchData.belongToMonth).slice(0,7),
        }
      }
    },
    data() {
      return {
        typeList:[],
        addN:0,
        projectList:[],
        searchParams:null,
        data: [],
        columns: [
          {
            type: 'index',
            width: 60,
            align: 'center'
          },
          {
            title: ' '
          },
          {
            title: '项目名称 ',
            align: 'center',
            key: 'projectName',
            width: 120,
          },
          {
            title: ' '
          },
          {
            title: '项目评级 ',
            align: 'center',
            key: 'projectGradeName',
            width: 120,
          },
          {
            title: ' '
          },
          {
            title: "项目评级系数",
            align: 'center',
            key: 'projectGradeRatio',
            width: 120,
          },
          {
            title: ' '
          },
          {
            title: '项目得分 ',
            align: 'center',
            key: 'projectGradeScore',
            width: 160,
          },
          {
            title: ' '
          },
          {
            title: '类型',
            align: 'center',
            key: 'storeFrontGradeTypeDtoList',
            width: 160,
            render: (h, params) => {
              let arr=params.row['storeFrontGradeTypeDtoList']
              let ret=[]
              arr.forEach(ele=>{
                ret.push(
                  h('div',{},ele.typeName+':'+ele.score+'*'+(ele.ratio*100).toFixed(2)+'%')
                )

              })


              return h('div',{},ret)
            }
          },
          {
            title: ' '
          },
          {
            title: "归属月份",
            align: 'center',
            key: 'belongMonth',
            width: 120,
          },
          {
            title: ' '
          },
          {
            title: "创建人",
            align: 'center',
            key: 'createUser',
            width: 120,
          },
          {
            title: ' '
          },

          {
            title: "创建日期",
            align: 'center',
            key: 'createDate',
            width: 120,
            render: (h, params) => {
              return h('span', {}, formatDateTime(params.row['createDate']))
            }
          },

          {
            title: ' '
          },
          {
            title: '操作',
            align: 'center',
            key: 'action',
            width: 170,
            fixed: 'right',
            render: (h, params) => {
              return h('div', [
                h('a', {
                  style: {
                    // display: params.row.reservationStatus === 2 ?'inline-block' :'none',
                    marginRight: '5px'
                  },
                  directives:[
                    {
                      name:'p',
                      value:{
                        api:'storeFrontGrade/deleteStoreFrontGrade'
                      }
                    }
                  ],
                  on:{
                    click: ()=>{
                      this.$Modal.confirm({
                        title: '删除',
                        content: '<p>确定删除该数据？</p>',
                        onOk: () => {
                          let params1={
                            storeFrontGradeFid:params.row['fid']
                          }
                          deleteStoreFrontGrade(params1).then(res=>{
                            this.$Message.success('删除成功')
                            this.page=1
                            this.current=1
                            this.getData()
                          }).catch(error=>{
                          })
                        }
                      })

                    }
                  }
                }, '删除'),

              ])
            }
          }
        ],
        total: 0,
        current: 1,
        loading: false,
        metaList:[],
        page:1,
        limit:10,
        searchData: {
          projectFid: '',
          createTime: ['', ''],
          belongToMonth:'',
        },
      }
    },
    methods: {
      getData(){
        let params={
          ...this.searchParams,
          page:this.page,
          limit:this.limit
        }
        findStoreFrontGradeList(params).then(res=>{
          if(!res.data){
            return
          }
          this.total=res.data.total
          this.data=res.data.rows?res.data.rows:[]

        }).catch(error=>{
        })

      },
      changPage(n){
        this.current = n;
        this.page = n;
        this.getData()
      },
      findData() {
        this.searchParams=this.searchDataComputed
        this.page=1
        this.current=1
        this.getData()
      },
      clearValue() {
        this.searchData = {
          projectFid: '',
          createTime: ['', ''],
          belongToMonth:'',
        }
      },
    },
  }
</script>

<style scoped>
  .width3 {
    width: 200px;
  }
</style>
